import { render, staticRenderFns } from "./TodoQuickBase.vue?vue&type=template&id=5f643e89&scoped=true&"
import script from "./TodoQuickBase.vue?vue&type=script&lang=js&"
export * from "./TodoQuickBase.vue?vue&type=script&lang=js&"
import style0 from "./TodoQuickBase.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./TodoQuickBase.vue?vue&type=style&index=1&id=5f643e89&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f643e89",
  null
  
)

export default component.exports